import { QueryParamValueType } from "@/types";
import { InputRef } from "antd";
import { createRef } from "react";
import { TableDropDownFilter } from "../TableDropDownFilter";
import { DropDownFilterButton } from "./DropdownFilterButton";

interface IProps {
  setQueryParamFunction: (key: string, value: unknown) => void;
  queryParamValue: QueryParamValueType;
  queryParamKey: string;
  options: unknown[];
  singleChoice?: boolean;
}

export const GetDropDownFilterProps = ({
  setQueryParamFunction,
  queryParamValue,
  queryParamKey,
  options,
  singleChoice,
}: IProps): object => {
  const inputRef = createRef<InputRef>();

  return {
    filterDropdown: ({ confirm }: { confirm: () => void }) => (
      <TableDropDownFilter
        inputRef={inputRef}
        onReset={(): void => setQueryParamFunction(queryParamKey, undefined)}
        onSubmit={(value: string | string[] | undefined): void => setQueryParamFunction(queryParamKey, value)}
        confirm={confirm}
        queryParamValue={queryParamValue}
        options={options}
        singleChoice={singleChoice}
      />
    ),
    filterIcon: () => (
      <DropDownFilterButton
        isActive={!!queryParamValue}
        data-test-id={"dropdown-filter-button"}
      />
    ),
    filterDropdownProps: {
      onOpenChange: (visible: boolean): void => {
        if (visible) {
          setTimeout(() => inputRef.current?.focus(), 100);
        }
      },
    },
  };
};
